import Marquee from "react-fast-marquee";

const items = [
  "SEO Services",
  "Link Building",
  "E-commerce SEO",
  "Shopify SEO",
  "Local SEO",
  "SaaS SEO",
];

export const ServiceMarquee = () => {
  return (
    <div
      data-testid="service-marquee"
      className="w-full border-y border-hairline bg-ink py-6 md:py-8"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-medium uppercase tracking-tight text-2xl md:text-4xl text-white/90 px-8">
              {item}
            </span>
            <span className="h-2 w-2 rounded-full bg-lime" />
          </div>
        ))}
      </Marquee>
    </div>
  );
};
